/**
 * 패널 플래닝 지도 스타일 상수 — Array / String / Module 스타일 중앙 집중
 *
 * SOLID:
 *  - SRP: 지도 폴리곤 스타일만 정의, PanelPlanningPage.vue에서 분리
 *  - DRY: 두 군데 중복(HIGHLIGHT_STYLE) 제거
 */
export const PANEL_MAP_STYLE = {
  array: {
    stroke: '#FF9800',
    fill: 'rgba(255,152,0,0.14)',
    strokeWidth: 3,
    haloExtra: 5
  },
  arraySelected: {
    stroke: '#E65100',
    fill: 'rgba(255,152,0,0.22)',
    strokeWidth: 3.5,
    haloExtra: 5
  },
  module: {
    stroke: '#00897B',
    fill: 'rgba(0,137,123,0.16)',
    strokeWidth: 2,
    haloExtra: 3
  },
  string: {
    stroke: '#1E88E5',
    fill: 'rgba(30,136,229,0.10)',
    strokeWidth: 2.5,
    haloExtra: 4
  },
  stringSelected: {
    stroke: '#0D47A1',
    fill: 'rgba(255, 213, 79, 0.28)',
    strokeWidth: 3,
    haloExtra: 4
  },
  moduleInStringSelection: {
    stroke: '#1976D2',
    fill: 'rgba(255, 255, 255, 0.26)',
    strokeWidth: 2,
    haloExtra: 3
  },
  moduleSelected: {
    stroke: '#00695C',
    fill: 'rgba(0, 137, 123, 0.38)',
    strokeWidth: 3,
    haloExtra: 4
  },
  vertexHandle: { fill: '#1565C0', stroke: '#FFFFFF', radius: 8 }
};
